import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from "@angular/router";

import { RouteCachingService } from "src/app/@theme/shared/services/route-caching.service";

export class CareersRouteReuseStrategy extends BaseRouteReuseStrategy {
  // route data property name used to set a component as reusable from withing the routing configuration
  private reusePropertyName: string = 'reuse';

  constructor(private _routeCachingService: RouteCachingService) {
    super();
  }

  /**
   * 2. Determines if a cached instance of the component for the target route exists.
   * If it returns true, Angular calls the `retrieve` method to restore the cached component.
   * If it returns false, Angular will create and initialize a new component instance.
   * @param route
   * @returns
   */
  override shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const isComponentCached: boolean = !!route.routeConfig && !!this._routeCachingService.retrieve(route);
    return isComponentCached;
  }

  /**
   * 3. Retrieves the cached component for the given route.
   * @param route
   */
  override retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const storedRoute = this._routeCachingService.retrieve(route);
    return storedRoute;
  }

  /**
   * 4. Determines if the component we are navigating away from should be cached.
   * If it returns true, Angular calls the `store` method to save the component for future use.
   * If it returns false, Angular destroys the component.
   * @param route
   * @returns
   */
  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const shouldDetachRoute: boolean = !!route.routeConfig && !!route.data[this.reusePropertyName];
    return shouldDetachRoute;
  }

   /**
   * 5. Stores the component for the given route in the cache
   * @param route
   * @param detachedTree
   */
  override store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    if (!!route.routeConfig && !!route.data[this.reusePropertyName] && detachedTree) {
      this._routeCachingService.store(route, detachedTree);
    }
  }
}
